import { DirectionsBoat } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { QuoteFormField, createdByField } from "./QuoteFormField";

export const QuoteInfo = ({ dataState, setDataState, requestMode = false, remarksRequired = false, editMode = false }) => {
  const { t } = useTranslation();
  const readOnly = dataState.isRevisionView;

  const baseFields = [
    {
      display: t("Currency"),
      required: true,
      code: "currencyCode",
      type: "foreignKey",
      entity: "Currency",
      filterField: "code",
      labelFields: ["Code"],
      fields: [
        { key: "Code", value: "currencyCode" },
        { key: "Id", value: "currencyId" },
      ],
    },
  ];
  const remarksField = {
    display: t("Remarks"),
    required: requestMode || remarksRequired,
    code: "remarks",
    type: "textArea",
    rows: 5,
    size: "100%",
    fullWidth: true,
  };
  const formFields = requestMode
    ? [createdByField(t), ...baseFields]
    : [
        createdByField(t),
        ...((editMode && !dataState.isMultiEdit) || readOnly
          ? [{ display: t("QuoteCode"), required: true, code: "quoteCode", type: "disabled" }]
          : []),
        ...((editMode && !dataState.isMultiEdit) || readOnly || dataState.revision
          ? [{ display: t("Revision"), required: false, code: "revision", type: "disabled" }]
          : []),
        { display: t("QuoteName"), required: true, code: "name", type: readOnly ? "disabled" : "text" },
        {
          display: t("Reference"),
          required: false,
          code: "reference",
          type: readOnly ? "disabled" : "text",
        },
        ...baseFields,
      ];

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <DirectionsBoat style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("QuoteInfo")}
          </div>
        }
        elements={
          <div style={{ width: "100%" }}>
            <div style={{ display: "grid", justifyItems: "center" }}>
              {formFields.map((field, index) => (
                <QuoteFormField
                  key={`quote-info-${field.code}`}
                  fields={field}
                  index={index}
                  data={dataState}
                  setData={setDataState}
                  toggleable={readOnly ? false : dataState.isMultiEdit}
                  disabled={readOnly}
                />
              ))}
            </div>
            <div style={{ width: "100%", marginTop: "15px" }}>
              <QuoteFormField
                fields={{
                  ...remarksField,
                  type: readOnly ? "disabled" : remarksField.type,
                }}
                data={dataState}
                setData={setDataState}
                disabled={readOnly}
              />
            </div>
          </div>
        }
      />
    </>
  );
};
